<template>
  <v-data-table
    :items="items"
    :headers="headers"
    :items-per-page="items.length + 1"
    hide-default-footer
    hide-default-header
    :sort-by="['display_order', 'nom']"
    :sort-desc="[false, false]"
    dense
    :search="search"
    :mobile-breakpoint="0"
    class="no-before"
  >
    <template v-slot:headers.display_order>
      <v-icon small>fa-list-ol</v-icon>
    </template>
    <template v-slot:item.display_order="{ item }"></template>
    <template v-slot:item.nom="{ item }">
      <v-text-field
        :ref="item.nom"
        :label="item.nom"
        hide-details
        flat
        type="tel"
        :value="item.quantity"
        @input="v => (item.quantity = Number(v))"
        :suffix="item.unit"
        @focus="$event.target.select()"
        @change="clearFocus"
      ></v-text-field>
    </template>
    <template v-slot:item.comments="{ item }">
      <v-row justify="end" align="center" no-gutters>
        <v-edit-dialog persistent large :return-value.sync="item.comments">
          <v-icon v-if="item.comments && item.comments.length > 0"
            >fa-sticky-note</v-icon
          >
          <v-icon v-else>far fa-sticky-note</v-icon>
          <template v-slot:input>
            <v-text-field
              v-model="item.comments"
              label="Commentaire"
              autofocus
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "InventoryRecordGrid",
  props: {
    items: {
      type: Array,
      required: true
    },
    search: {
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          value: "display_order",
          text: "",
          sort: function(a, b) {
            if (a === b) {
              return 0;
            } else if (a === null) {
              return 1;
            } else if (b === null) {
              return -1;
            } else {
              return a < b ? -1 : 1;
            }
          },
          width: 25
        },
        { value: "nom", text: "Quantité" },
        { value: "comments", text: "Commentaire", width: 25 }
      ]
    };
  },
  methods: {
    clearFocus() {
      document.activeElement.blur();
    }
  }
};
</script>

<style lang="scss" scoped></style>
